/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfUserGroupDto } from '../../models/platform-api-result-of-user-group-dto';
import { PlatformCreateUserGroup } from '../../models/platform-create-user-group';

export interface PostUsergroups$Params {
      body: PlatformCreateUserGroup
}

export function postUsergroups(http: HttpClient, rootUrl: string, params: PostUsergroups$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
  const rb = new RequestBuilder(rootUrl, postUsergroups.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserGroupDto>;
    })
  );
}

postUsergroups.PATH = '/api/usergroups';
